<div class="drop-container"
  #dropContainer
  [id]="dropId"
  (contextmenu)="onDropRightClick($event)"
  [ngClass]="wrapperClass$ | async"
  [style]="getDropStyle()"
  (mousemove)="onDragOver($event)"
  (mouseleave)="onDragLeave($event)">
  
  @if (drop?.shelves?.length) {
    @for (shelf of drop?.shelves; track shelfIndex; let shelfIndex = $index) {

      <!-- 🟩 Show shelf placeholder BEFORE each shelf -->
      <div *ngIf="placeholderService.shouldShowShelfPlaceholder(dropIndex, shelfIndex)"
        class="shelf-wrapper shelf-placeholder">
        <app-planogram-manual-shelf
          [dropIndex]="dropIndex"
          [shelfIndex]="shelfIndex"
          [shelf]="(placeholderService.placeholder$ | async)!.shelf"
          [shelfNumber]="getShelfNumber(shelfIndex)"
          [shelfSettings]="getShelfSettings(shelfIndex)"
          [dropLipHeight]="drop?.lipHeight">
        </app-planogram-manual-shelf>
      </div>

      <div class="shelf-wrapper"
       *ngIf="!shelf.dragging"
        [style]="((shelfStyles$ | async) ?? {})[shelfIndex]">
        <app-planogram-manual-shelf
          [attr.data-shelftype]="getShelfType(shelf)"
          [dropIndex]="dropIndex"
          [shelfIndex]="shelfIndex"
          [shelfSettings]="getShelfSettings(shelfIndex)"
          [shelfNumber]="getShelfNumber(shelfIndex)"
          [shelf]="shelf"
          [dropLipHeight]="drop?.lipHeight">
        </app-planogram-manual-shelf>

        <div class="shelf-handle"
          (mousedown)="onShelfMouseDown($event, shelfIndex)"
          (contextmenu)="onShelfRightClick($event, shelfIndex)">
        </div>
      </div>
    }

    <!-- 🟩 Placeholder AFTER the last shelf -->
    <div *ngIf="drop && drop.shelves && placeholderService.shouldShowShelfPlaceholder(dropIndex, drop.shelves.length)"
         class="shelf-placeholder">
        <app-planogram-manual-shelf
          [dropIndex]="dropIndex"
          [shelfIndex]="drop.shelves.length"
          [shelf]="(placeholderService.placeholder$ | async)!.shelf"
          [shelfNumber]="getShelfNumber(drop.shelves.length)"
          [shelfSettings]="getShelfSettings(drop.shelves.length)"
          [dropLipHeight]="drop.lipHeight">
        </app-planogram-manual-shelf>
    </div>
  } @else {
    <!-- 🟩 Empty Drop Placeholder -->
    <div *ngIf="placeholderService.shouldShowShelfPlaceholder(dropIndex, 0)"
        class="shelf-placeholder">
      <app-planogram-manual-shelf
        [dropIndex]="dropIndex"
        [shelfIndex]="0"
        [shelf]="(placeholderService.placeholder$ | async)!.shelf"
        [shelfNumber]="getShelfNumber(0)"
        [shelfSettings]="getShelfSettings(0)"
        [dropLipHeight]="drop?.lipHeight">
      </app-planogram-manual-shelf>
    </div>
    <div class="empty-drop-message" *ngIf="!placeholderService.shouldShowShelfPlaceholder(dropIndex, 0)">
      No shelves to display.
    </div>
  }
</div>